import http from '../../shared/http.js';
import { withFlash } from '../../shared/flash.js';
import { initFormModalLinks } from '../../shared/formModal.js';
import { confirmAction, hideLoading, notifyError, showLoading } from '../../shared/notify.js';

// What each row button does, so the handler below stays a lookup rather than a
// chain of ifs. `confirm` is null where the action is harmless enough to run
// straight away - only deactivation and deletion interrupt with a dialog.
const ACTIONS = {
  activate: {
    confirm: null,
    loading: 'Benutzer wird aktiviert …',
    flash: 'benutzer-aktiviert',
    run: (id) => http.patch(`/users/${id}/status`, { isActive: true })
  },
  deactivate: {
    confirm: (name) => ({
      title: 'Benutzer deaktivieren',
      message: `Möchten Sie ${name} wirklich deaktivieren? Die Anmeldung ist danach nicht mehr möglich.`,
      okText: 'Deaktivieren'
    }),
    loading: 'Benutzer wird deaktiviert …',
    flash: 'benutzer-deaktiviert',
    run: (id) => http.patch(`/users/${id}/status`, { isActive: false })
  },
  delete: {
    confirm: (name) => ({
      title: 'Benutzer löschen',
      message: `Möchten Sie ${name} endgültig löschen? Das kann nicht rückgängig gemacht werden.`,
      okText: 'Löschen'
    }),
    loading: 'Benutzer wird gelöscht …',
    flash: 'benutzer-geloescht',
    run: (id) => http.delete(`/users/${id}`)
  }
};

export function initUserList() {
  const list = document.getElementById('user-list');
  if (!list) return;

  // Creating and editing happen in the shared dialog rather than on their own
  // page. The links keep their href, so a middle click still opens the real
  // page and nothing breaks with the bundle absent - initFormModalLinks only
  // intercepts a plain left click.
  //
  // Delegated from document, because the "create" button sits in the page
  // header rather than inside the table.
  initFormModalLinks({
    selector: 'a[href$="/new"], a[href$="/edit"]',
    // No live refresh on this list yet, so the page reload is what shows the
    // change - the same round trip it did before, minus the one it used to
    // take to reach the form.
    onSaved: () => window.location.reload()
  });

  // One delegated listener for the whole table, so rows cost nothing to add.
  list.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-action]');
    if (!button) return;

    const action = ACTIONS[button.dataset.action];
    if (!action) return;

    const { userId, userName } = button.dataset;

    if (action.confirm && !(await confirmAction(action.confirm(userName)))) return;

    button.disabled = true;
    showLoading(action.loading);

    try {
      await action.run(userId);
      window.location.href = withFlash('/users', action.flash);
    } catch (err) {
      hideLoading();
      button.disabled = false;
      notifyError(
        err.response?.data?.message || 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.'
      );
    }
  });
}
